import { z } from 'zod';
import { zGoDate, zGoSlice } from '../helpers/fix-go-types';
import { StoreSalesStatsSchema } from './store-sales-stat';

// One month-end inventory valuation (models.InventoryValue). `month` is a packed
// YYYYMM number (202609); `as_of` is when the upload started, a real instant —
// render it with formatInStoreTimezone. Negative on-hand quantities count as
// zero, so totals can run slightly above LiquorPOS's own valuation report.
export const InventoryValueSchema = z.object({
  month: z.number(),
  as_of: zGoDate,
  qty_on_hand: z.number(),
  cost: z.number(),
  replacement: z.number(),
  retail: z.number(),
});

export type InventoryValue = z.infer<typeof InventoryValueSchema>;

// models.StoreStats. `sales` is exactly the legacy sales_stats shape.
export const StoreStatsSchema = z.object({
  sales: StoreSalesStatsSchema,
  inventory: z.object({
    // Go serializes a nil `[]InventoryValue` (no omitempty) as null.
    value_history: zGoSlice(InventoryValueSchema),
  }),
});

export type StoreStats = z.infer<typeof StoreStatsSchema>;
